import { SortableHeaderCell } from "./styled";
export default SortableHeaderCell;